import React from 'react';
import PropTypes from 'prop-types';

const SuccessIcon = ({ size = 18, color = '#20AB66' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 18 18" fill="none">
    <g>
      <path fill={color} d="M9,0C4,0,0,4,0,9s4,9,9,9s9-4,9-9S14,0,9,0z M9,16.7c-4.2,0-7.7-3.5-7.7-7.7S4.8,1.3,9,1.3s7.7,3.5,7.7,7.7S13.2,16.7,9,16.7z" />
      <polygon fill={color} points="8,10.1 5.7,7.8 4.3,9.2 8,12.9 13.7,7.2 12.3,5.8" />
    </g>
  </svg>
);

SuccessIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default SuccessIcon;
